<div class="max-w-3xl mx-auto px-4 py-16">
  <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
    Politique de Confidentialité
  </h1>
  <p class="text-sm text-gray-400 mb-8">Dernière mise à jour : mars 2026</p>
  <div class="text-gray-600 dark:text-gray-400 space-y-6">
    <section>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
        Données collectées
      </h2>
      <p>
        Nous collectons les données nécessaires au fonctionnement du service :
        email, nom du commerce, données de ventes saisies, localisation
        (optionnelle).
      </p>
    </section>
    <section>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
        Utilisation des données
      </h2>
      <p>
        Vos données sont utilisées pour générer des recommandations
        personnalisées et améliorer l'algorithme de prévision. Elles ne sont
        jamais vendues à des tiers.
      </p>
    </section>
    <section>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">Stockage</h2>
      <p>
        Les données sont hébergées en Europe. Nous appliquons des mesures de
        sécurité conformes aux standards du secteur.
      </p>
    </section>
    <section>
      <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
        Vos droits (RGPD)
      </h2>
      <p>
        Vous disposez d'un droit d'accès, de rectification et de suppression de
        vos données. Pour exercer ces droits :
        <a routerLink="/contact" class="text-purple-600 hover:underline"
          >nous contacter</a
        >.
      </p>
    </section>
  </div>
</div>
